
import React, { useEffect, useRef, useState } from "react";

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Spinner,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
} from "reactstrap";
import { BASE_URL } from "../../utils/constants";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import PanelHeader from "components/PanelHeader/PanelHeader";
import { MDBDataTableV5 } from "mdbreact";
import { IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import MyBragSheetTableInput from "./MyBragSheetTableInput";
import Select from 'react-select';

// import EditIcon from "@mui/icons-material/Edit";

const MyBragSheetTopCoursesTable = (props) => {
    // const setData = props.setData;
    const [rowFirst, setRowFirst] = useState(props.courseOptions.length ? props.courseOptions[0].skills : "")
    const [rowFirstFocused, setRowFirstFocused] = useState(false)
    const [rowSecond, setRowSecond] = useState(props.courseOptions.length > 1 ? props.courseOptions[1].skills : "")
    const [rowSecondFocused, setRowSecondFocused] = useState(false)
    const [rowThird, setRowThird] = useState(props.courseOptions.length > 2 ? props.courseOptions[2].skills : "")
    const [rowThirdFocused, setRowThirdFocused] = useState(false)
    return (
        <Card className="p-3">
            {props.children}
            <hr />
            <CardBody
                className="bg-light"
            >
                <MDBDataTableV5
                    id={props.id}
                    hover
                    responsive
                    borderless={false}
                    bordered
                    striped
                    entriesOptions={[5, 20, 25]}
                    entries={5}
                    pagesAmount={4}
                    data={{
                        ...props.data, rows: [
                            props.courseOptions.length ? {
                                course: (
                                    <Select
                                        closeMenuOnSelect={true}
                                        options={props.courseOptions}
                                        onChange={(e) => {
                                            props.handleSelectCourse(0, e);
                                        }}
                                        value={props.courseOptions[0]}
                                    />
                                ),
                                skills: (
                                    <input
                                        type="text"
                                        value={rowFirstFocused ? rowFirst : props.courseOptions[0].skills}
                                        onChange={(e) => {
                                            setRowFirst(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            props.handleInputCourseSkill(0, rowFirst, e);
                                            setRowFirstFocused(false)
                                            // setRowFirst("");
                                        }}
                                        onFocus={_ => {
                                            setRowFirst(props.courseOptions[0].skills);
                                            setRowFirstFocused(true)
                                        }}
                                    />
                                )
                            } : {}
                            ,
                            props.courseOptions.length > 1 ? {
                                course: (
                                    <Select
                                        closeMenuOnSelect={true}
                                        options={props.courseOptions}
                                        onChange={(e) => {
                                            props.handleSelectCourse(1, e);
                                        }}
                                        value={props.courseOptions[1]}
                                    />
                                ),
                                skills: (
                                    <input
                                        type="text"
                                        value={rowSecondFocused ? rowSecond : props.courseOptions[1].skills}
                                        onChange={(e) => {
                                            setRowSecond(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            props.handleInputCourseSkill(1, rowSecond, e);
                                            setRowSecondFocused(false)
                                            // setRowSecond("");
                                        }}
                                        onFocus={_ => {
                                            setRowSecond(props.courseOptions[1].skills);
                                            setRowSecondFocused(true)
                                        }}
                                    />
                                )
                            } : {}
                            ,
                            props.courseOptions.length > 2 ? {
                                course: (
                                    <Select
                                        closeMenuOnSelect={true}
                                        options={props.courseOptions}
                                        onChange={(e) => {
                                            props.handleSelectCourse(2, e);
                                        }}
                                        value={props.courseOptions[2]}
                                    />
                                ),
                                skills: (
                                    <input
                                        type="text"
                                        value={rowThirdFocused ? rowThird: props.courseOptions[2].skills}
                                        onChange={(e) => {
                                            setRowThird(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            props.handleInputCourseSkill(2, rowThird, e);
                                            setRowThirdFocused(false)
                                            // setRowThird("");
                                        }}
                                        onFocus={_ => {
                                            setRowThird(props.courseOptions[2].skills);
                                            setRowThirdFocused(true)
                                        }}
                                    />
                                )
                            } : {}
                            ,
                        ]
                    }}
                    fullPagination={false}
                    paging={false}
                    searchTop
                    searchBottom={false}
                />
            </CardBody>

            <div className="text-center d-flex">
                <button
                    className="btn btn-primary fw-bolder mx-auto w-25"
                    onClick={props.saveFunction}
                >
                    Save
                </button>
            </div>

        </Card>
    )
}

export default MyBragSheetTopCoursesTable